import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './AddToPremiumCard.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { Button } from '@/components/UI/Button/Button';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';
import { AddToPremiumModal } from '@/components/AdsWithInfiniteScroll/PremiumAdsWithInfiniteScroll/AddToPremiumModal';
import { CommonTestIds } from '@/__e2e__/testIds/common';

export const AddToPremiumCard = () => {
  const { t } = useTranslation();
  const [isOpen, toggleModal] = useToggleOpenState();
  return (
    <>
      <S.Card
        onClick={toggleModal}
        data-testid={CommonTestIds.addToPremium.card}
      >
        <S.IconWrapper>
          <IconBox
            $filename="crown.svg"
            $width={28}
            $height={24}
            $iconWidth={28}
            $iconHeight={24}
          />
        </S.IconWrapper>
        <S.Content>
          <S.Title>{t('pages.ad.add_to_premium')}</S.Title>
          <Button isFullWidth appearance="secondary" borderRadius={14}>
            {t('pages.ad.make_premium')}
          </Button>
        </S.Content>
      </S.Card>
      <AddToPremiumModal isOpen={isOpen} onClose={() => toggleModal(false)} />
    </>
  );
};

AddToPremiumCard.displayName = 'AddToPremiumCard';
